module.exports = "<button type=\"button\" class=\"btn btn-primary\" \n    (click)=\"retrieveImg()\" *ngIf=\"!isLoading\">\n{{button_label}}\n</button>\n<div style=\"text-align: center; font-weight: bold; color: #5f9ff3;\" \n    *ngIf=\"isLoading\">\n    Retrieving...<mat-spinner diameter=\"40\" style=\"margin: auto;\"></mat-spinner>\n</div>"


//////////////////
// WEBPACK FOOTER
// /opt/tglfc/olap/salary_web/src/app/components/app-view-img/app-view-img.component.html
// module id = ../../../../../src/app/components/app-view-img/app-view-img.component.html
// module chunks = main